import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=e6281ca6&scoped=true&"
import script from "./CustomerHeader.vue?vue&type=script&lang=js&"
export * from "./CustomerHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=e6281ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6281ca6",
  null
  
)

export default component.exports